import React from "react";
import { Regular6Style } from "./css/Regular6Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const regular_1_6 = (props) => {
  return (
    <Regular6Style>
      <div className="template-wrapper">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="t6-containersix">
          <div className="t6-img-wrapper t6-woman">
            <TemplateImage slideType={props.slideType} file={props.file} />
          </div>
          <div className="t6-text-wrappers">
            <TemplateText
              id={props.id}
              text={props.text}
              textStyle={props.textStyle}
              editStatus={props.editStatus}
              onInputSlideText={props.onInputSlideText}
            />
          </div>
        </div>
      </div>
    </Regular6Style>
  );
};

export default regular_1_6;
